// Detect when charts have scorlled into the viewport so we can trigger animations
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.remove('is-offscreen');
    }
  });
},
{
  // add top offset so we can see the first bar before the animation starts
  rootMargin: '80px 0px 0px 0px',
  threshold: [0]
});

document.querySelectorAll('.BarChart, .ButterflyChart, .Card-bar').forEach((el) => observer.observe(el));
